// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__MnQdM","MobileNavigation":"Navbar_MobileNavigation__Ejjbk","Navigation":"Navbar_Navigation__H1Zdi","Hamburger":"Navbar_Hamburger__2RRFK"};